@if (loading()) {
  <div
    [class.loading-overlay-in-block]="inBlock()"
    [class.loading-overlay-over-header]="overHeader()"
    [class.loading-wrapper]="true"
  >
    <div class="loading-wrapper-container">
      <div class="logo-wrapper">
        <div class="logo-animation">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="font"></div>
        <div class="loading-description-text">Načítám, prosím čekejte...</div>
      </div>
    </div>
  </div>
}
